import { createContext, useContext, useEffect, useState } from "react";

const ResponsiveContext = createContext(null);

export const BREAKPOINTS = {
  desktop: 1200,
  tablet: 768,
  mobile: 0
};

function getModeFromWidth(width) {
  if (width >= BREAKPOINTS.desktop) return "desktop";
  if (width >= BREAKPOINTS.tablet) return "tablet";
  return "mobile";
}

export function ResponsiveProvider({ children }) {
  const [autoMode, setAutoMode] = useState("desktop");
  const [overrideMode, setOverrideMode] = useState(null); // null = no override
  const [previewEnabled, setPreviewEnabled] = useState(false);

  useEffect(() => {
    function handleResize() {
      const detected = getModeFromWidth(window.innerWidth);
      setAutoMode(prev => (prev !== detected ? detected : prev));
    }

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const mode = previewEnabled && overrideMode
    ? overrideMode
    : autoMode;

  return (
    <ResponsiveContext.Provider
      value={{
        mode,
        autoMode,
        overrideMode,
        setOverrideMode,
        previewEnabled,
        setPreviewEnabled
      }}
    >
      {children}
    </ResponsiveContext.Provider>
  );
}

export function useResponsive() {
  return useContext(ResponsiveContext);
}